import { render, staticRenderFns } from "./Insert.vue?vue&type=template&id=ebf0d9fc&scoped=true"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"
import style0 from "./Insert.vue?vue&type=style&index=0&id=ebf0d9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf0d9fc",
  null
  
)

export default component.exports